import { formatDate } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { OtpVerifyComponent } from "src/app/shared-modules/otp-verify/otp-verify.component";
import { TruckOwnerService } from "../truck-owner.service";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { DeleteAccountComponent } from "../delete-account/delete-account.component";

@Component({
  selector: "app-profile",
  templateUrl: "./profile.component.html",
  styleUrls: ["./profile.component.css"],
})
export class ProfileComponent implements OnInit {
  public editGeneralInfo = false;
  public editBillingDetails = false;
  public editBankDetails = false;
  public mobileVerified = 0;
  public emailVerified = 0;
  public updateBtn = true;
  public profileUpdates = "NA";
  public profileUpdateButton = false;
  public billingSave = false;
  bankSave: boolean = false;
  public save = false;
  public edit1 = true;
  public edit2 = true;
  public edit3 = true;
  profileForm!: FormGroup;
  billingForm!: FormGroup;
  bankForm!: FormGroup;
  maxDate = new Date();
  file: any = "";
  profileImage: any = "";
  dateFormat = "yyyy-MM-dd";
  language = "en";
  loading: boolean = false;
  token: any;
  invalidDate: boolean = false;
  MatDialogref: MatDialogRef<DeleteAccountComponent>;
  matDialogref: MatDialogRef<OtpVerifyComponent> | undefined;
  data = {
    username: "",
    mobile: 0,
    email: "",
    dob: new Date(),
    gender: "",
    company_name: "",
    profile_pic: "",
    designation: "",
    gst: "",
    sms_alert: false,
    account_details: {
      account_name: "",
      accountr_number: "",
      bank_name: "",
      branch_name: "",
      ifsc_code: "",
    },
    billing_address: {
      username: "",
      address_line: "",
      area_name: "",
      city: "",
      state: "",
      pincode: "",
      mobile: "",
      gst: "",
      landmark: "",
    },
  };
  profileLoading: boolean = false;

  emailregex =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,3}))$/;

  constructor(
    private router: Router,
    private formBuilder: FormBuilder,
    private services: TruckOwnerService,
    private matDialog: MatDialog,
    private snackBar: MatSnackBar
  ) {}

  ngOnInit(): void {
    this.token = sessionStorage.getItem("to_token");
    this.profileForm = this.formBuilder.group({
      userName: [
        "",
        [Validators.required, Validators.pattern("^[a-zA-Z][a-zA-Z\\s]+$")],
      ],
      mobile: [
        "",
        Validators.compose([
          Validators.required,
          Validators.pattern("^[0-9]{4,10}$"),
        ]),
      ],
      email: ["", Validators.compose([Validators.pattern(this.emailregex)])],
      dateOfBirth: [""],
      gender: [""],
      companyName: ["", [Validators.pattern("^[A-Za-z0-9? ,_-]+$")]],
      designation: [""],
      gst: ["", Validators.compose([Validators.pattern("[A-Z0-9]{15}")])],
      sms_alert: [false],
    });
    this.billingForm = this.formBuilder.group({
      billingName: [
        "",
        [Validators.required, Validators.pattern("^[a-zA-Z][a-zA-Z\\s]+$")],
      ],
      billingContact: [
        "",
        [Validators.required, Validators.pattern("^[0-9]{10,10}$")],
      ],
      address: ["", [Validators.required]],
      area: ["", [Validators.required]],
      city: ["", [Validators.required]],
      state: ["", [Validators.required]],
      pincode: ["", [Validators.required, Validators.pattern("^[0-9]{6,6}$")]],
      gst: ["", Validators.compose([Validators.pattern("[A-Z0-9]{15}")])],
    });
    this.bankForm = this.formBuilder.group({
      account_name: [""],
      accountr_number: [""],
      bank_name: [""],
      branch_name: [""],
      ifsc_code: [""],
    });
    this.getProfile();
    if (this.token == null) {
      this.router.navigateByUrl("/");
    }
  }

  public get ProfileFormControl() {
    return this.profileForm.controls;
  }
  public get BillingFormControl() {
    return this.billingForm.controls;
  }
  public get BankFormControl() {
    return this.bankForm.controls;
  }

  public formatFormDate(date: Date) {
    return formatDate(date, this.dateFormat, this.language);
  }

  public getProfile(): void {
    let token = sessionStorage.getItem("to_token");
    this.services.GetProfile(token).subscribe((response: any) => {
      if (response.status === 200) {
        if (
          response.body.data.billing_address === null ||
          response.body.data.billing_address === undefined
        ) {
          response.body.data.billing_address = {};
          this.data = response.body.data;
        } else {
          this.data = response.body.data;
          this.profileForm.patchValue({
            sms_alert: this.data.sms_alert
          });
        }
        this.profileImage = response.body.data.profile_pic;
        this.mobileVerified = response.body.data.mobile_verified;
        this.emailVerified = response.body.data.email_verified;
      }
    });
  }

  public onEditProfile(num: number): void {
    this.updateBtn = false;
    this.profileUpdateButton = true;
    this.save = true;
    this.edit1 = false;
    this.edit2 = false;
    if (!this.editGeneralInfo) {
      this.ProfileFormControl["userName"].setValue(this.data.username);
      this.ProfileFormControl["mobile"].setValue(this.data.mobile);
      this.ProfileFormControl["email"].setValue(this.data.email);
      this.ProfileFormControl["companyName"].setValue(this.data.company_name);
      this.ProfileFormControl["designation"].setValue(this.data.designation);
      this.ProfileFormControl["dateOfBirth"].setValue(this.data.dob);
      this.ProfileFormControl["gender"].setValue(this.data.gender);
      this.ProfileFormControl["gst"].setValue(this.data.gst);
      this.ProfileFormControl["sms_alert"].setValue(this.data.sms_alert);
      if (this.data.dob != null) {
        this.profileForm.patchValue({
          dateOfBirth: this.formatFormDate(this.data.dob),
        });
      }
    }
    if (num === 1) {
      this.editGeneralInfo = true;
    }
  }

  onEditBankDetails() {
    this.bankSave = true;
    this.billingSave = false;
    this.save = false;
    this.profileUpdateButton = false;
    this.save = false;
    this.edit1 = false;
    this.edit2 = false;
    this.editBankDetails = true;
    if (this.editBankDetails) {
      this.BankFormControl["account_name"].setValue(
        this.data.account_details.account_name
      );
      // this.BankFormControl["accountr_number"].setValue(
      //   this.data.account_details.accountr_number
      // );
      this.bankForm.patchValue({
        accountr_number: this.data.account_details.accountr_number,
      });
      this.BankFormControl["bank_name"].setValue(
        this.data.account_details.bank_name
      );
      this.BankFormControl["branch_name"].setValue(
        this.data.account_details.branch_name
      );
      this.BankFormControl["ifsc_code"].setValue(
        this.data.account_details.ifsc_code
      );
    }
  }

  onEditBillingAddress() {
    this.billingSave = true;
    this.profileUpdateButton = false;
    this.save = false;
    this.edit1 = false;
    this.edit2 = false;
    this.editBillingDetails = true;
    if (this.editBillingDetails) {
      this.BillingFormControl["billingName"].setValue(
        this.data.billing_address.username
      );
      this.BillingFormControl["address"].setValue(
        this.data.billing_address.address_line
      );
      this.BillingFormControl["area"].setValue(
        this.data.billing_address.area_name
      );
      this.BillingFormControl["city"].setValue(this.data.billing_address.city);
      this.BillingFormControl["state"].setValue(
        this.data.billing_address.state
      );
      this.BillingFormControl["pincode"].setValue(
        this.data.billing_address.pincode
      );
      this.BillingFormControl["billingContact"].setValue(
        this.data.billing_address.mobile
      );
      this.BillingFormControl["gst"].setValue(this.data.billing_address.gst);
    }
  }

  public onChange(event: any): void {
    this.file = event.target.files[0];
    this.profileLoading = true;
    this.services.uploadImage(this.file).subscribe((response: any) => {
      if (response.status === 201) {
        this.profileLoading = false;
        this.profileImage = response.body.image_link;
      }
    });
  }

  GoToDashboard() {
    this.router.navigate(["transporter/trucks"]);
  }

  public updateProfile(): void {
    if (this.profileForm.valid) {
      this.loading = true;
      this.profileUpdates = "NA";
      let token = sessionStorage.getItem("to_token");
      const profileData = {
        username: this.ProfileFormControl["userName"].value,
        mobile: this.ProfileFormControl["mobile"].value,
        email: this.ProfileFormControl["email"].value,
        dob: this.ProfileFormControl["dateOfBirth"].value,
        gender: this.ProfileFormControl["gender"].value,
        company_name: this.ProfileFormControl["companyName"].value,
        profile_pic: this.profileImage,
        designation: this.ProfileFormControl["designation"].value,
        gst: this.ProfileFormControl["gst"].value,
        sms_alert: this.ProfileFormControl["sms_alert"].value,
      };
      this.services
        .UpdateProfile(profileData, token)
        .subscribe((response: any) => {
          if (response.status === 200) {
            this.loading = false;
            this.data = response.body.data;
            this.profileImage = response.body.data.profile_pic;
            this.mobileVerified = response.body.data.mobile_verified;
            this.emailVerified = response.body.data.email_verified;
            this.editBillingDetails = false;
            this.editGeneralInfo = false;
            this.profileUpdateButton = false;
            this.save = false;
            this.edit1 = true;
            this.edit2 = true;
            sessionStorage.setItem("to_ProfilePic", this.profileImage);
            sessionStorage.setItem("to_userName", this.data.username);
            this.profileUpdates = "success";
          }
        });
      this.updateBtn = false;
      this.getProfile();
    } else {
      this.invalidDate = false;
      if (this.ProfileFormControl["dateOfBirth"].value > this.maxDate) {
        this.invalidDate = true;
      }
      this.profileForm.markAllAsTouched();
    }
  }
  updateBankDetails() {
    if (this.bankForm.valid) {
      this.loading = true;
      let token = sessionStorage.getItem("to_token");
      const bankData = {
        account_details: {
          account_name: this.BankFormControl["account_name"].value,
          accountr_number: this.BankFormControl["accountr_number"].value,
          bank_name: this.BankFormControl["bank_name"].value,
          branch_name: this.BankFormControl["branch_name"].value,
          ifsc_code: this.BankFormControl["ifsc_code"].value,
        },
      };
      this.services.UpdateProfile(bankData, token).subscribe(
        (response: any) => {
          if (response.status === 200) {
            this.loading = false;
            this.data = response.body.data;
            this.editBankDetails = false;
            this.profileUpdateButton = false;
            this.save = false;
            this.bankSave = false;
            this.edit1 = true;
            this.edit2 = true;
          }
        },
        (error) => {
          if (error.status == 403) {
            this.router.navigateByUrl("/");
            sessionStorage.clear();
          }
          if (error.status == 401) {
            this.router.navigateByUrl("/");
            sessionStorage.clear();
          }
          if (error.error.message === "jwt malformed") {
            this.router.navigateByUrl("/");
            sessionStorage.clear();
          }
          if (error.error.message === "jwt expired") {
            this.router.navigateByUrl("/");
            sessionStorage.clear();
          }
          this.snackBar.open(error.error.message, "Fail", {
            duration: 5000,
          });
        }
      );
      this.getProfile();
    } else {
      this.billingForm.markAllAsTouched();
    }
  }
  updateBillingAddress() {
    if (this.billingForm.valid) {
      this.loading = true;
      let token = sessionStorage.getItem("to_token");
      const billingData = {
        billing_address: {
          username: this.BillingFormControl["billingName"].value,
          address_line: this.BillingFormControl["address"].value,
          area_name: this.BillingFormControl["area"].value,
          city: this.BillingFormControl["city"].value,
          state: this.BillingFormControl["state"].value,
          pincode: this.BillingFormControl["pincode"].value,
          mobile: this.BillingFormControl["billingContact"].value,
          gst: this.BillingFormControl["gst"].value,
          landmark: "",
        },
      };
      this.services.UpdateProfile(billingData, token).subscribe(
        (response: any) => {
          if (response.status === 200) {
            this.loading = false;
            this.data = response.body.data;
            this.editBillingDetails = false;
            this.profileUpdateButton = false;
            this.save = false;
            this.billingSave = false;
            this.edit1 = true;
            this.edit2 = true;
          }
        },
        (error) => {
          if (error.status == 403) {
            this.router.navigateByUrl("/");
            sessionStorage.clear();
          }
          if (error.status == 401) {
            this.router.navigateByUrl("/");
            sessionStorage.clear();
          }
          if (error.error.message === "jwt malformed") {
            this.router.navigateByUrl("/");
            sessionStorage.clear();
          }
          if (error.error.message === "jwt expired") {
            this.router.navigateByUrl("/");
            sessionStorage.clear();
          }
          this.snackBar.open(error.error.message, "Fail", {
            duration: 5000,
          });
        }
      );
      this.getProfile();
    } else {
      this.billingForm.markAllAsTouched();
    }
  }

  public SendOtp(): void {
    const dataValue = {
      email: this.data.email,
      displayText: "Email Address",
    };
    this.matDialogref = this.matDialog.open(OtpVerifyComponent, {
      width: "500px",
      data: {
        dataKey: dataValue,
      },
      autoFocus: false,
    });

    this.matDialog._getAfterAllClosed().subscribe((result: any) => {
      this.emailVerified = 1;
    });
  }
  deleteaccount(item: any) {
    this.MatDialogref = this.matDialog.open(DeleteAccountComponent, {
      width: "500px",
      data: item,
      autoFocus: false,
    });
  }

  validateNumber(event: KeyboardEvent) {
    const input = String.fromCharCode(event.keyCode);
    if (!/[0-9]/.test(input)) {
      event.preventDefault();
    }
  }

  onPasteNumber(event: ClipboardEvent) {
    const clipboardData = event.clipboardData || (window as any).clipboardData;
    const pastedText = clipboardData.getData('text');
    if (!/^[0-9]+$/.test(pastedText)) {
      event.preventDefault();
    }
  }

  editPreOrder() {
    sessionStorage.setItem("preorder_setting", "preOrderSetting");
    this.router.navigateByUrl("/transporter/pre-order-settings");
  }
}
